export default "__VITE_ASSET__085f6832__"